import { Component, Injector, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Demand } from '../../types/Demand';
import { ActivatedRoute } from '@angular/router';
import { DemandDataService } from '../../demand-data.service';
import { CommentDataService } from '@lib/comment';
import { ItemClassificationDataService } from '@lib/classification';
import { FileDataService } from '@lib/file';

@Component({
    template: '',
    standalone: false
})
export abstract class AbstractDemandDialogComponent<Data> {
    readonly route = inject(ActivatedRoute);
    readonly dataService = inject(DemandDataService);
    readonly commentDataService = inject(CommentDataService);
    readonly itemClassificationDataService = inject(ItemClassificationDataService);
    readonly fileDataService = inject(FileDataService);
    readonly injector = inject(Injector);
    private readonly dialog = inject(MatDialog);


    public get insideDialog(): boolean {
        return !!this.dialogRef;
    }

    public abstract getDemand(): Promise<Demand>;

    public closeDialog(demand: Demand): void {
        if (this.insideDialog) {
            this.dialogRef?.close(demand);
        }
    }

    protected get dialogRef(): MatDialogRef<AbstractDemandDialogComponent<Data>> | undefined {
        return this.dialog.openDialogs.find((ref) => ref.componentInstance === this);
    }
}
